export var copilotRouteGuard = function (props) {
    var _a, _b;
    var canActivate = !!((_b = (_a = props.featureGates) === null || _a === void 0 ? void 0 : _a.copilotGates) === null || _b === void 0 ? void 0 : _b.copilotCmciframeEnabled);
    return { canActivate: canActivate };
};
//# sourceMappingURL=copilotRouteGuard.js.map